import styled from 'styled-components';
import { common } from 'themes/default';
import { bookingStatus } from 'types/booking';

const { PROVISIONAL, ON_HOLD, TEMPORARILY_ON_HOLD, CONFIRMED, REFUNDED, CANCELLED } = bookingStatus;

const getStatusStyles = (status) => {
  switch (status) {
    case CANCELLED:
      return common.notifications.error;
    case CONFIRMED:
      return common.notifications.success;
    case PROVISIONAL:
    case ON_HOLD:
    case TEMPORARILY_ON_HOLD:
      return common.notifications.alert;
    case REFUNDED:
    default:
      return common.notifications.information;
  }
};

export const Status = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0.5rem;

  ${({ status }) => {
    const styles = getStatusStyles(status);
    return `
      background-color: ${styles.backgroundColour};
      color: ${styles.fontColour};
    `;
  }}
`;

export const StatusImage = styled.img`
  display: block;
  margin: 0 0.5rem 0 0;
`;
